import React, {useEffect, useState} from 'react';
import {
    ButtonCell,
    Cell,
    List,
    Section,
    Input, Button, Textarea
} from '@telegram-apps/telegram-ui';
import {
    FcBookmark,
    FcBusinessContact,
    FcCalendar,
    FcDeleteRow, FcFlashOff,
    FcFlashOn,
    FcRefresh,
} from "react-icons/fc";
import InfoFooter from "../component/InfoFooter";
import {
    add_mutual_bot_api,
    delete_mutual_bot_api,
    get_mutual_bots_api,
    reboot_mutual_bot_api,
} from "../api/AdminAPI";
import toast from "react-hot-toast";
import WebApp from "@twa-dev/sdk";
import {FaCheckCircle} from "react-icons/fa";
import {BsBootstrapReboot} from "react-icons/bs";


function MutualBotManagement() {
    const [botList, setBotList] = useState([] as ResponseMutualEntity[]);
    const [token, setToken] = useState("");
    const [teacherName, setTeacherName] = useState("");
    const [startReply, setStartReply] = useState("<b>妹子花名：品茗老师</b>\n" +
        "妹子风骚、水多身材好\n" +
        "服务项目：鸳鸯浴、漫游、毒龙、口爆、深喉\n" +
        "400 一次全套\n" +
        "700 两次\n" +
        "1500 包夜不限次\n" +
        "\n" +
        "1912560xxxx  约课打我的电话敲定时间等你哦\n" +
        "开课地址：xx省xx市xx区xxx小区\n" +
        "\n" +
        "以上仅为案例，请有需要的老师联系管理员申请！");
    const [teacherId, setTeacherId] = useState(0);

    useEffect(() => {
        update_bot_list()
    }, [])
    const update_bot_list = () => {
        get_mutual_bots_api()
            .then(res => {
                setBotList(res.data.data)
                toast.success(res.data.message)
            })
    }
    const onAddMutualBot = () => {
        var mutual_entity = {} as ResponseMutualEntity;
        mutual_entity.token = token;
        mutual_entity.teacher_id = teacherId;
        mutual_entity.teacher_name = teacherName;
        mutual_entity.start_reply = startReply;
        add_mutual_bot_api(mutual_entity).then(res => {
            toast.success(res.data.message)
        })
    }

    return (
        <div>
            <List>
                <Section header={"新增双向机器人"}>

                    <Input header="输入Token" placeholder="输入Token"
                           value={token}
                           type={"text"}
                           onChange={e => setToken(e.target.value)}/>
                    <Input header="输入老师名称" placeholder="输入老师名称"
                           value={teacherName}
                           type={"text"}
                           onChange={e => setTeacherName(e.target.value)}/>
                    <Input header="输入TeacherId" placeholder="输入TeacherId"
                           value={teacherId}
                           type={"number"}
                           onChange={e => setTeacherId(Number(e.target.value))}/>
                    <Textarea header="回复内容"
                              placeholder="{teacher_name}老师名称，{teacher_id}老师ID"
                              value={startReply}
                              onChange={e => {
                                  setStartReply(e.target.value)
                              }}
                              maxLength={1000}
                              style={{minHeight: 200}}
                    />
                    <div style={{
                        display: "flex",
                        width: "100%",
                        justifyContent: "center",
                        alignItems: "center",
                        minHeight: "60px"
                    }}>
                        <Button style={{width: "80%"}}
                                before={<FaCheckCircle size={16}/>}
                                mode="filled"
                                size="m"
                                onClick={e => onAddMutualBot()}
                        >添加 </Button>
                    </div>
                </Section>
                <Section header="双向机器人列表">
                    <ButtonCell before={<FcRefresh size={"20"}/>}
                                onClick={e => {
                                    update_bot_list()
                                }}>
                        刷新列表
                    </ButtonCell>
                    {
                        botList.length === 0 &&
                        <Cell description="请在上方添加">暂无运行中的机器人</Cell>
                    }
                    {
                        botList.map(item =>
                            <div>
                                <Cell Component="label"
                                      before={item.running ? <FcFlashOn size={"20"}/> : <FcFlashOff size={"20"}/>}
                                      description={"回复:" + item.start_reply}
                                      subhead={"ID:" + item.teacher_id}
                                      subtitle={"token:" + item.token}
                                >
                                    {item.teacher_name}
                                </Cell>
                                <ButtonCell before={<BsBootstrapReboot size={"20"}/>}
                                            onClick={e => {
                                                WebApp.showConfirm("确定重启【" + item.teacher_name + "】吗？", (r) => {
                                                    if (r) {
                                                        reboot_mutual_bot_api(item.token).then(res => {
                                                            toast.success(res.data.message);
                                                        })
                                                        WebApp.HapticFeedback.impactOccurred("soft")
                                                    } else {
                                                        return;
                                                    }
                                                })
                                            }}>
                                    ↑重启机器人
                                </ButtonCell>
                                <ButtonCell before={<FcDeleteRow size={"20"}/>}
                                            onClick={e => {
                                                WebApp.showConfirm("确定移除【" + item.teacher_name + "】吗？", (r) => {
                                                    if (r) {
                                                        delete_mutual_bot_api(item.token).then(res => {
                                                            toast.success(res.data.message);
                                                        })
                                                        WebApp.HapticFeedback.impactOccurred("soft")
                                                    } else {
                                                        return;
                                                    }
                                                })
                                            }}>
                                    ↑移除机器人
                                </ButtonCell>
                            </div>
                        )
                    }
                </Section>
                <InfoFooter/>
            </List>
        </div>
    );
}

export default MutualBotManagement;
